import { FeatureCommandHandlerAdapter } from '@core/infrastructure/features/command-handler.adapter';
import { WishlistPublicCommands } from '@features/wishlist/public.api';

export class WishlistCommandHandlerAdapter extends FeatureCommandHandlerAdapter<null> {}

export const makeCommandWishlistCommandHandler = () => ({
    module: 'WishlistFeatureCoreModule',
    path: () => import('@features/wishlist/wishlist-feature.core.module').then((m) => m.WishlistFeatureCoreModule),
    key: WishlistPublicCommands.LOAD_WISHLIST,
    props: null,
});
